var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-3 orange"},[_c('div',[_vm._v("There is no data to display")])])
}
var staticRenderFns = []

export { render, staticRenderFns }